const CLOCK_COLOUR_PATH =
  "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/";

export class ScoresByQuarterMini {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "ScoreQBQMini";
    this.scene = "ScoreQBQMini";
    this.data = [];
    this.page = 1360;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    xml.payload.field.find((item) => {
      return item.attr.name === "00200"; // Number
    }).value = options.game?.home_team?.code;

    xml.payload.field.find((item) => {
      return item.attr.name === "00300"; // Number
    }).value = options.game?.away_team?.code;

    xml.payload.field.find((item) => {
      return item.attr.name === "0004"; // Number
    }).value = options.period + 1;

    let scores = [
      {
        home: options.game?.scores_by_quarter?.home?.first,
        away: options.game?.scores_by_quarter?.away?.first,
      },
      {
        home: options.game?.scores_by_quarter?.home?.second,
        away: options.game?.scores_by_quarter?.away?.second,
      },
      {
        home: options.game?.scores_by_quarter?.home?.third,
        away: options.game?.scores_by_quarter?.away?.third,
      },
      {
        home: options.game?.scores_by_quarter?.home?.fourth,
        away: options.game?.scores_by_quarter?.away?.fourth,
      },
    ];

    for (let i = 1; i <= options.period; i++) {
      xml.payload.field.find((item) => {
        return item.attr.name === "0" + i + "0"; // Number
      }).value = "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + i + "01"; // Number
      }).value = i > 4 ? "Extra Time" : "Quarter " + i;

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + i + "02"; // Number
      }).value = scores[i - 1]?.home ?? "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0" + 1 + "03"; // Number
      }).value = scores[i - 1]?.away ?? "0";
    }
    xml.payload.field.find((item) => {
      return item.attr.name === "0" + (options.period + 1) + "01"; // Number
    }).value = "Total";

    xml.payload.field.find((item) => {
      return item.attr.name === "0" + (options.period + 1) + "0"; // Number
    }).value = "2";

    xml.payload.field.find((item) => {
      return item.attr.name === "0" + (options.period + 1) + "02"; // Number
    }).value = options.game?.scores_by_quarter?.home?.goals ?? "0";
    xml.payload.field.find((item) => {
      return item.attr.name === "0" + (options.period + 1) + "03"; // Number
    }).value = options.game?.scores_by_quarter?.away?.goals ?? "0";

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
